/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntersectionObserver } from '@micromag/core/hooks';

import styles from '../../../../styles/guest/partials/section.module.scss';


const propTypes = {
    children: PropTypes.node,
    onChange: PropTypes.func,
    scrollTo: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    children: null,
    onChange: null,
    scrollTo: null,
    className: null,
};

const Section = ({ children, onChange, scrollTo, className }) => {

    const {
        ref,
        entry: { isIntersecting = false },
    } = useIntersectionObserver({ rootMargin: '-50%' });

    useEffect( () => {
        if (isIntersecting && onChange !== null) {
            onChange();
        }
    }, [isIntersecting]);

    useEffect( () => {
        if (scrollTo) {
            const currentTop = ref.current.offsetTop;
            if (window.scrollY !== currentTop) {
                window.scrollTo({ top: currentTop });
            }
        }
        
    }, [scrollTo]);

    return (
        <section
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            ref={ref}
        >
            { children }
        </section>
    );
};

Section.propTypes = propTypes;
Section.defaultProps = defaultProps;

export default Section;
